<template>
  <div class="add-merchant">
    <v-modal :modalName="modalName" class="add-merchant__container">
      <template slot="header">
        <div class="add-merchant__container__header">
          <span class="add-merchant__container__header--title">Create merchant</span>
          <v-btn
            text
            large
            fab
            @click="toggleMerchantModal()"
            class="add-merchant__container__header--close"
          >
            <font-awesome-icon icon="times" />
          </v-btn>
        </div>
      </template>
      <template slot="body">
        <div class="add-merchant__container__form">
          <div class="add-merchant__container__form__inputs">
            <!--Name-->
            <label for="name">Name</label>
            <input
              name="name"
              type="text"
              placeholder="Name"
              onfocus="this.placeholder=''"
              onblur="this.placeholder"
              v-model="merchant.name"
              :rules="rules.requiredRules"
              :autofocus="'autofocus'"
              class="add-merchant__container__form__inputs--field"
            />

            <!--Description-->
            <label for="description">Description</label>
            <textarea
              name="description"
              type="text"
              label="Description"
              placeholder="Description"
              onfocus="this.placeholder=''"
              onblur="this.placeholder"
              v-model="merchant.description"
              :rules="rules.requiredRules"
              class="add-merchant__container__form__inputs--field text-area"
            />
          </div>
          <div>
            <v-btn-toggle v-model="merchant.category" class="add-merchant__container__form--group">
              <v-btn depressed>Eat</v-btn>
              <v-btn depressed>Shop</v-btn>
              <v-btn depressed>Do</v-btn>
            </v-btn-toggle>
          </div>

          <v-img
            v-show="!image"
            src="@/assets/upload.png"
            @click="uploadImg()"
            class="add-merchant__container__form--icon"
          />
          <input ref="input" type="file" accept="image/*" @change="stageImg" />
          <v-row>
            <v-col>
              <v-img
                :src="image"
                :aspect-ratio="1 / 1"
                @click="uploadImg()"
                class="add-merchant__container__form--logo"
              />
            </v-col>
          </v-row>
        </div>
      </template>
      <template slot="footer">
        <div class="add-merchant__container__footer">
          <v-btn text fab @click="createMerchant" class="check">
            <font-awesome-icon icon="check" />
          </v-btn>
        </div>
      </template>
    </v-modal>

    <v-alert type="error" v-if="this.errors.name">Name required</v-alert>
    <v-alert type="error" v-if="this.errors.description">Description required</v-alert>
    <v-alert type="error" v-if="this.errors.image">Image required</v-alert>
  </div>
</template>

<script>
import imageCropper from "@/components/cropper/imageCropper";
import VModal from "@/components/VModal";
import rules from "@/rules.js";
const uuid = require("uuid/v4");

import { mapActions, mapState } from "vuex";

export default {
  name: "addMerchant",

  components: {
    imageCropper,
    VModal
  },

  data() {
    return {
      modalName: "add-merchant",

      merchant: {
        category: "",
        description: "",
        image: "",
        name: "",
        type: "merchant"
      },

      rules,
      errors: {
        name: false,
        description: false,
        image: false
      },

      aspectRatio: 1 / 1
    };
  },

  methods: {
    ...mapActions({
      toggleMerchantModal: "ui/merchantModalState",
      toggleCropperModal: "ui/cropperModalState",
      newMerchant: "merchants/createMerchant",
      removeImg: "cropper/clear",
      sendImage: "cropper/imageToCrop"
    }),

    validInput() {
      if (!this.merchant.name) {
        this.errors.name = true;
        return true;
      } else this.errors.name = false;

      if (!this.merchant.description) {
        this.errors.description = !this.errors.description;
        return true;
      } else this.errors.description = false;

      if (!this.merchant.image) {
        this.errors.image = true;
        return true;
      }
    },

    async createMerchant() {
      if (this.merchant.category === 0) this.merchant.category = "eat";
      if (this.merchant.category === 1) this.merchant.category = "shop";
      if (this.merchant.category === 2) this.merchant.category = "do";
      const result = await this.validInput();

      if (result) {
        return;
      } else {
        let logoId = uuid();
        let merchantPayload = {
          id: uuid(),
          logo: logoId,
          type: this.merchant.type,
          name: this.merchant.name,
          category: this.merchant.category,
          description: this.merchant.description,
          _attachments: {
            [logoId]: {
              data: this.merchant.image.replace("data:image/jpeg;base64,", ""),
              content_type: "image/jpeg"
            }
          }
        };

        await this.newMerchant(merchantPayload);
        this.toggleMerchantModal();
        this.removeImg();
      }
    },

    stageImg(data) {
      this.sendImage(data);
    },

    async uploadImg() {
      this.$refs.input.click();
      this.toggleCropperModal();
    }
  },

  computed: {
    ...mapState({ cropper: state => state.cropper }),

    image() {
      return this.cropper.postCrop;
    },

    submit() {
      if (
        this.merchant.name &&
        this.merchant.description &&
        this.merchant.category &&
        this.merchant.image
      ) {
        return true;
      }
    }
  },

  watch: {
    "cropper.postCrop": function(val) {
      this.merchant.image = val;
      console.log(val);
    }
  }
};
</script>

<style lang="sass" scoped>

.add-merchant
  position: fixed
  width: 100%
  height: 100%
  left: 0
  top: 0
  display: flex
  flex-flow: column
  justify-content: center
  backdrop-filter: blur(4px)
  background: rgba($c-black, .3)
  z-index: 10

  &__container
    width: 400px
    height: 650px
    transform: scale(.7)
    border-radius: 15px
    box-shadow: -2px -1px 5px rgba(0, 0, 0, .3)

    &__header
      &--title
        position: relative
        left: 120px

      &--close
        position: relative
        top: -20px
        left: 180px

    &__form
      &__inputs
        display: flex
        flex-flow: column
        position: relative
        margin-bottom: 30px

        &--field
          outline: none    
          transition: all .3s
          margin: 10px 0

          &:hover, &:focus
            border: 1px solid $dark-purple  

        .text-area
          text-indent: 0 

      &--group
        position: relative
        left: 80px
        border-radius: 30px

      &--icon
        margin: 20px auto
        width: 50px

      &--logo
        margin: 0 auto
        width: 100px
        margin-top: 20px

    &__footer
      position: relative
      display: flex
      justify-content: center
      height: 100px
      padding: 30px


</style>
